var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 29,
    viewBox: "0 0 41 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4699 9.17163C40.2821 8.90024 40.0313 8.67841 39.7391 8.52516C39.4468 8.3719 39.1217 8.29179 38.7917 8.29168H10.8882L8.53212 2.63626C8.2232 1.8915 7.70008 1.25525 7.0291 0.808173C6.35812 0.361094 5.56949 0.123324 4.76321 0.125009H0V4.20834H4.76321L14.4489 27.4527C14.604 27.8246 14.8657 28.1423 15.2011 28.3657C15.5364 28.5892 15.9304 28.7084 16.3333 28.7083H32.6667C33.518 28.7083 34.2796 28.1796 34.5797 27.3853L40.7047 11.052C40.8205 10.7429 40.8596 10.4104 40.8187 10.0829C40.7778 9.75544 40.6581 9.44275 40.4699 9.17163ZM31.2518 24.625H17.6951L12.591 12.375H35.8455L31.2518 24.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.6258020d428bd41fe3d7822703bd0a63.svg";
export { ForwardRef as ReactComponent };